/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniDocumentArrowDown = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-document-arrow-down ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M4.5 2C3.67157 2 3 2.67157 3 3.5V16.5C3 17.3284 3.67157 18 4.5 18H15.5C16.3284 18 17 17.3284 17 16.5V7.62132C17 7.2235 16.842 6.84197 16.5607 6.56066L12.4393 2.43934C12.158 2.15804 11.7765 2 11.3787 2H4.5ZM9.25 8.75C9.25 8.33579 9.58579 8 10 8C10.4142 8 10.75 8.33579 10.75 8.75V11.2955L11.6925 10.2483C11.9696 9.94039 12.4438 9.91543 12.7517 10.1925C13.0596 10.4696 13.0846 10.9438 12.8075 11.2517L10.5575 13.7517C10.4152 13.9098 10.2126 14 10 14C9.78739 14 9.58476 13.9098 9.44253 13.7517L7.19253 11.2517C6.91544 10.9438 6.94039 10.4696 7.24828 10.1925C7.55616 9.91544 8.03038 9.94039 8.30747 10.2483L9.25 11.2955V8.75Z"
        fill="#7041F1"
        fillRule="evenodd"
      />
    </svg>
  );
};
